"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGtmContext = exports.getUpdatedParameters = exports.GtmContextProvider = exports.GtmContext = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/**
 * This provides the default configuration for the GtmContext
 */
var GtmContext = /*#__PURE__*/(0, _react.createContext)({
  lob: null,
  airlineProfile: null,
  service: null
});
exports.GtmContext = GtmContext;
var GtmContextProvider = function GtmContextProvider(_ref) {
  var children = _ref.children,
    config = _ref.config;
  var lob = config.lob,
    airlineProfile = config.airlineProfile,
    service = config.service;
  var memoizedConfig = (0, _react.useMemo)(function () {
    return {
      lob: lob,
      airlineProfile: airlineProfile,
      service: service
    };
  }, [lob, airlineProfile, service]);
  return /*#__PURE__*/_react.default.createElement(GtmContext.Provider, {
    value: memoizedConfig
  }, children);
};
exports.GtmContextProvider = GtmContextProvider;
var useGtmContext = function useGtmContext() {
  var context = (0, _react.useContext)(GtmContext);
  if (context === undefined) {
    console.error('useGtmContext must be used within a GtmContextProvider with a required config props');
    return null;
  }
  return context;
};
exports.useGtmContext = useGtmContext;
var getUpdatedParameters = function getUpdatedParameters(gtmParameters, context, category, description) {
  var updatedDescription = description || 'Addon heatmap';
  var key = category || 'eventCategory';
  var service = (context === null || context === void 0 ? void 0 : context.service) || 'OTA';
  return _objectSpread(_objectSpread({}, gtmParameters), {}, (0, _defineProperty2.default)({}, key, "".concat(service, "|").concat(updatedDescription)));
};
exports.getUpdatedParameters = getUpdatedParameters;
GtmContextProvider.propTypes = {
  children: _propTypes.default.element.isRequired,
  config: _propTypes.default.objectOf(_propTypes.default.string).isRequired
};